import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactNotifications } from "react-notifications-component";
import { inboxActions } from "../../_store";
import { storeCurrentRoute } from "../../utils/routeTracker";
import { getStoredValue } from "../../_helpers/storagehelper";

const ArchivedMessagesPage = () => {
  const navigate = useNavigate();
  //const { results } = location.state || { results: [] };
  const { results, loading, error } = useSelector((state) => state.archived);
  const [showPopup, setShowPopup] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const userID = getStoredValue("userID");

  const defaultParams = {
    userID: userID,
    inmateID: 0,
    subject: "",
    fromDate: "",
    toDate: "",
    messageStatus: 0,
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "",
  };
  const [currentPage, setCurrentPage] = useState(defaultParams?.pageNo);
  const [isSearch, setIsSearch] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [searchpageNo, setSearchpageNo] = useState(0);
  const [loadedPages, setLoadedPages] = useState(new Set());
  const [searchloadedPages, setSearchLoadedPages] = useState(new Set());
  const [filteredInboxMessageList, setFilteredInboxMessageList] = useState([]);
  const dispatch = useDispatch();


  const InitialFindInboxMessage = {
    userID: userID,
    InmateID: 0,
    FromDate: "",
    ToDate: "",
    MessageStatus: 0,
    Subject: "", // Ensure this is set to an empty string initially
    StatusOptions: "1", // Default to "All"
  };

  const [findInboxMesage, setFindInboxMessage] = useState(InitialFindInboxMessage);

  const handleBuyCredits = () => {
    setShowPopup(true);
  };

  const confirmNavigation = () => {
    setShowPopup(false);
    navigate("/public/PurchaseCredits");
    storeCurrentRoute("/public/PurchaseCredits");
  };

  const cancelNavigation = () => {
    setShowPopup(false);
  };


  const goBack = () => {
    navigate("/public/Archived");
    storeCurrentRoute("/public/Archived");
  };
  // const handleClick = (message) => {
  //   navigate("public/Messenger", { state: { message: message.MessageID } });
  // };
  const handleClick = (messages) => {
    navigate("/public/Messenger", {
      state: {
        MessageID: messages.MessageID,
        PublicUserID: messages.PublicUserID,
        CODMessageCount: messages.CODMessageCount,
      },
    });
    storeCurrentRoute("/public/Messenger");
  };


  const handleSearch = async (IsLoadMore) => {
    // Calculate the new page number
    let newPageNo = 1;
    setIsSearch(true);

    if (IsLoadMore) {
      newPageNo = searchpageNo + 1;
      if (searchloadedPages.has(newPageNo)) {
        setHasMoreData(false);
        return;
      }
    } else {
      setFilteredInboxMessageList([]);
      const resetLoadedPages = new Set();
      resetLoadedPages.add(newPageNo); // Add the first page to prevent duplicate fetches
      setSearchLoadedPages(resetLoadedPages);
    }
    const getStatusString = (statusValue) => {
      switch (statusValue) {
        case "2":
          return currentPage?.ArchivedPage?.Read;
        case "3":
          return "Unread";
        case "4":
          return "Rejected";
        case "5":
          return "Waiting";
        default:
          return "All"; // For "1" or any unexpected values, treat as "All"
      }
    };

    const { InmateID, FromDate, ToDate, Subject, StatusOptions } = findInboxMesage;
    const statusFilter = getStatusString(StatusOptions); // Convert StatusOptions to the appropriate value

    try {
      // Prepare the request payload based on defaultParams and the search filters
      const requestPayload = {
        ...defaultParams, // Spread the defaultParams to maintain initial values
        inmateID: InmateID,
        fromDate: FromDate,
        toDate: ToDate,
        messageStatus: statusFilter === "All" ? 0 : StatusOptions, // Adjust MessageStatus based on filter
        subject: Subject,
        pageNo: newPageNo, // Always start with page 1 for the search
        rowCountPerPage: 15, // Set the number of rows per page
      };

      // Call the API to fetch the filtered data
      const response = await dispatch(
        inboxActions.LoadInboxMessages({
          ...requestPayload,
          append: true, // Indicate this is not for appending
        })
      );

      if (response?.payload && response?.payload.length > 0) {
        if (newPageNo === 1) {
          setHasMoreData(true);
          setFilteredInboxMessageList([]);
          // Ensure the clearing takes effect before setting new data
          // setTimeout(() => {
          setFilteredInboxMessageList(response.payload);
          // }, 0);
        } else {
          setFilteredInboxMessageList((prev) => [...prev, ...response.payload]); // Append new data to existing data
        }

        // Update loaded pages to prevent fetching the same page again
        setSearchLoadedPages((prev) => {
          const updatedSearchLoadedPages = new Set(prev);
          updatedSearchLoadedPages.add(newPageNo);
          return updatedSearchLoadedPages;
        });

        // Update page number state for future requests
        setSearchpageNo(newPageNo); // Increment page number for next load

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        // Stop loading if no data is returned
        setHasMoreData(false);
      }
    } catch (error) {
      console.error("Error fetching search data:", error);
    }
  };

  const handleLoadMore = async () => {
    // Calculate the new page number
    const newPageNo = pageNo + 1;
    const InmateID = 0

    // Check if the page has already been loaded to prevent re-fetching
    if (loadedPages.has(newPageNo)) {
      setHasMoreData(false);
      return;
    }
    dispatch(
      inboxActions.LoadInboxMessages({ ...defaultParams, pageNo: newPageNo, InmateID: results[0].InmateID })
    ).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        setFilteredInboxMessageList((prev) => [...prev, ...response.payload]); // Append new data to existing data

        // Update loaded pages to prevent fetching the same page again
        setLoadedPages((prevLoadedPages) => {
          const updatedLoadedPages = new Set(prevLoadedPages);
          updatedLoadedPages.add(newPageNo);
          return updatedLoadedPages;
        });

        // Update page number state for future requests
        setPageNo(newPageNo);

        // If fewer items are returned than requested, stop loading
        if (response.payload.length < defaultParams?.rowCountPerPage) {
          setHasMoreData(false); // No more data available, hide "Load More"
        }
      } else {
        setHasMoreData(false);
      }
    });
  };

  return (
    <div>
      <ReactNotifications />
      <div className="">
        <div className="d-flex justify-content-between align-items-center">
          <div className="header-title">
            <h5>
              Archived Messages
            </h5>
          </div>
          <button
            type="button"
            onClick={goBack}
            className="btn btn-danger me-1 mb-2"
          >
            <i class="fa-solid fa-arrow-left me-1"></i>
            Back
          </button>

        </div>
      </div>

      <div className="card shadow-lg">
        <div className="card-body">
          {results && results.length > 0 ? (
            results.map((message) => (
              <div
                key={message.MessageID}
                className="d-flex flex-column border-bottom py-3"
                onClick={() => handleClick(message)}
              // key={index} // Use unique key
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <i
                      className="fa fa-user-circle fa-2x text-dark me-3"
                      style={{ fontSize: "30px" }}
                    ></i>
                    <div>
                      <h6 className="mb-1 font-size-15">{message.MessageFrom}</h6>
                      <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                        {message.MessageSubject}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex flex-column align-items-end">
                    <span
                      className="text-muted mb-2"
                      style={{ fontSize: "12px" }}
                    >
                      {message.MessageSendDateTime}
                    </span>
                    <div className="d-flex justify-content-end align-items-center flex-wrap">
                      <div className="d-flex align-items-center justify-content-center mr-2 ">
                        <button className="btn btn-success btn-sm min-width-80 ">
                          <h5 className="available-limit text-white">
                            ${message.CreditBalance.toFixed(2)}
                          </h5>
                        </button>

                      </div>
                      <div className="d-flex align-items-center">
                        {message.IsAllowSendReply === 1 && (<button
                          id="btnBuyCredits"
                          type="button"
                          title="Buy Credits"
                          className="btn btn-danger btn-sm"
                          onClick={handleBuyCredits}
                        >
                          Buy Credits
                        </button>)}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-5">
              <h5 className="text-muted">No messages available</h5>
            </div>
          )}
        </div>
      </div>
      {hasMoreData && (
        <li className="list-group-item">
          <div className="d-flex justify-content-center mb-n3">
            <div className="div-load-more-data inbox panel footer-load-more">
              <label
                className="text-decoration-none text-danger fs-5 cursor-pointer load-more-button"
                onClick={
                  isSearch ? () => handleSearch(true) : handleLoadMore
                }
              >
                <i class="fa-solid fa-plus me-1 font-size-14"></i>Load More
              </label>
            </div>
          </div>
        </li>
      )}
      {showPopup && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Message</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={cancelNavigation}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  This action redirects into another page. Are you sure you want
                  to proceed?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={confirmNavigation}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={cancelNavigation}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(ArchivedMessagesPage);
